import React, { useState, useEffect } from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import Icons from '~/Common-Objects/UI/Icons/index'
import Row from '~/Common-Objects/Grids/Row/Row'
import { useHistory, useParams } from 'react-router-dom';
import i18n from '~/i18n';

export default function SiteAnalyzerFinished({ job, setJob = () => { }, back = () => { }, next = () => { } }) {

    const history = useHistory()


    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    const exit = (goToTemplates) => {
        if (goToTemplates) {
            //go to the branded group
            history.push("/cp/templates/add/1/1")
            return;
        }

        history.push("/");

    }

    const params = new URLSearchParams(window.location.search)
    let forwardUrl = params.get('forward')

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div style={{ maxWidth: '720px', width: '100%' }}>
                <h4 className="mar-b10 text-center">
                    {i18n.t('templates:brandAnalyzer.finishedPage.heading')}
                </h4>
                <div className="mar-b25 text-center">
                    {i18n.t('templates:brandAnalyzer.finishedPage.subHeading')}
                </div>

                <Row>
                    <Column xs={12} sm={6} md={6} className="mar-b25">
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            {[{
                                title: i18n.t('templates:brandAnalyzer.finishedPage.logoTitle'),
                                sub: i18n.t('templates:brandAnalyzer.finishedPage.logoSub')
                            }, {
                                title: i18n.t('templates:brandAnalyzer.finishedPage.coloursTitle'),
                                sub: i18n.t('templates:brandAnalyzer.finishedPage.coloursSub')
                            }, {
                                title: i18n.t('templates:brandAnalyzer.finishedPage.imageryTitle'),
                                sub: i18n.t('templates:brandAnalyzer.finishedPage.imagerySub')
                            }, {
                                title: i18n.t('templates:brandAnalyzer.finishedPage.typographyTitle'),
                                sub: i18n.t('templates:brandAnalyzer.finishedPage.typographySub')
                            }, {
                                title: i18n.t('templates:brandAnalyzer.finishedPage.contactInfoTitle'),
                                sub: i18n.t('templates:brandAnalyzer.finishedPage.contactInfoSub')
                            }].map((item, idx) => (
                                <div key={`brand-finish-${idx}`} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '12px 16px', border: '0.5px solid var(--neutral-200)', backgroundColor: 'var(--neutral-50)', borderRadius: '12px' }}>
                                    <Icons icon='tickCircle' style={{ width: '20px', height: '20px' }} />
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <div style={{ fontWeight: 600, fontSize: '13px', lineHeight: '18px', color: 'var(--neutral-950)' }}>{item.title}</div>
                                        <div style={{ fontWeight: 400, fontSize: '13px', lineHeight: '18px', color: 'var(--neutral-600)' }}>{item.sub}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Column>
                    <Column xs={12} sm={6} md={6} className="mar-b25">
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                            <img src="https://cdn1.ourmailsender.com/siteContent/brandAnalyzer/finished_image1.png" style={{ width: "100%", border: '1px solid #eee', borderRadius: '20px' }} />
                        </div>
                    </Column>
                </Row>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px' }}>
                    <p style={{ textAlign: "center", margin: 0, fontWeight: 500 }}>{i18n.t('templates:brandAnalyzer.finishedPage.weveCreatedBrandedTemplates')}</p>
                    <Button
                        text={i18n.t('templates:brandAnalyzer.finishedPage.exploreEmailTemplates')}
                        className="button-primary"
                        postHogTag="brand-analyzer-create-first-email"
                        onClick={() => exit(true)}
                        iconRight={<Icons icon="arrowRight" />}
                    />
                    <span style={{ textAlign: "center", color: 'var(--neutral-600)', fontSize: '12px', lineHeight: '18px' }}>{i18n.t('templates:brandAnalyzer.finishedPage.youCanEditCompanyInformation')}</span>
                </div>
            </div>
        </div>
    )
}